import { ArrowLeft } from "lucide-react";
import { Link } from "@inertiajs/react";
import AppLayout from "../../layouts/AppLayout";
import CandidateForm from "./_CandidateForm";

interface Firm {
  id: number;
  name: string;
}

interface Candidate {
  id: number;
  first_name: string;
  last_name: string;
  middle_initial: string;
  preferred_first_name: string;
  email: string;
  phone: string;
  firm_id: number | null;
  firm_name: string;
  candidate_type: string;
  jd_year: number | null;
  law_school: string;
  undergrad: string;
  practice_area: string;
  specialties: string;
  location: string;
  admitted: string;
  languages: string;
  degrees: string;
  honors: string;
  origin_firm: string;
  profile_url: string;
  linkedin_url: string;
  pipeline_stage: string;
  priority: string;
  source: string;
  notes: string;
  intake_date: string | null;
  leopard_id: string;
}

interface Props {
  candidate: Candidate;
  firms: Firm[];
}

export default function CandidateEdit({ candidate, firms }: Props) {
  const initialValues = {
    ...candidate,
    firm_id: candidate.firm_id ? String(candidate.firm_id) : "",
    jd_year: candidate.jd_year ? String(candidate.jd_year) : "",
    intake_date: candidate.intake_date
      ? new Date(candidate.intake_date).toISOString().split("T")[0]
      : "",
  };

  return (
    <AppLayout title={`Edit — ${candidate.first_name} ${candidate.last_name}`}>
      <div className="max-w-3xl mx-auto">
        <Link href={`/candidates/${candidate.id}`} className="inline-flex items-center gap-1 text-sm text-gray-500 hover:text-gray-700 mb-4">
          <ArrowLeft className="w-4 h-4" /> {candidate.first_name} {candidate.last_name}
        </Link>
        <h1 className="text-2xl font-bold text-gray-900 mb-6">Edit Candidate</h1>
        <CandidateForm
          initialValues={initialValues}
          firms={firms}
          submitUrl={`/candidates/${candidate.id}`}
          method="patch"
          submitLabel="Save Changes"
          cancelUrl={`/candidates/${candidate.id}`}
        />
      </div>
    </AppLayout>
  );
}
